module.exports = __webpack_public_path__ + "img/icon_white_tag.915dc4ca.png";